// Generated by CoffeeScript 1.11.1
(function() {
  var BlendMode;

  BlendMode = require('../blend_mode');

  module.exports = {
    parseBlendModes: function() {
      this.blendMode = new BlendMode(this.file);
      this.blendMode.parse();
      this.opacity = this.blendMode.opacity;
      this.visible = this.blendMode.visible;
      return this.clipped = this.blendMode.clipped;
    },
    hidden: function() {
      return !this.visible;
    },
    blendingMode: function() {
      return this.blendMode.mode;
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer/blend_modes.js
// module id = 47
// module chunks = 0